export default () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 37 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.5 37C28.7173 37 37 28.7173 37 18.5C37 8.28273 28.7173 0 18.5 0C8.28273 0 0 8.28273 0 18.5C0 28.7173 8.28273 37 18.5 37ZM17.5203 10L17.5203 17.9797H10V19.4797H17.5203V27H19.0203V19.4797H27V17.9797H19.0203L19.0203 10H17.5203Z"
      fill="currentColor"
    />
  </svg>
);
